import React, { useState } from 'react';
import {
    Box,
    Button,
    Form,
    FormField,
    Header,
    Heading,
    Spinner,
    Text,
    TextInput,
    TextArea
} from 'grommet';

const Contact = () => {
    const [value, setValue] = useState({});
    const [submitting, setSubmitting] = useState(false);

    return (
        <Box gap="medium" width="medium" alignSelf='center' pad={{top: 'large'}}>
            <Header
                direction="column"
                align="start"
                gap="xxsmall"
                pad={{ horizontal: 'xxsmall' }}
            >
                <Heading level={2} margin="none">
                    Contact claim3
                </Heading>
                <Text>Get in touch with claim3 creators</Text>
            </Header>
            <Box
                // Padding used to prevent focus from being cutoff
                pad={{ horizontal: 'xxsmall' }}
            >
                <Form
                    value={value}
                    onChange={nextValue => setValue(nextValue)}
                    onReset={() => setValue({})}
                    onSubmit={({ value }) => { }}
                >
                    <FormField name="first-name" htmlFor="first-name-input-id" label="First Name">
                        <TextInput id="first-name-input-id" name="first-name" plain={false}/>
                    </FormField>
                    <FormField name="last-name" htmlFor="last-name-input-id" label="Last Name">
                        <TextInput id="last-name-input-id" name="last-name" />
                    </FormField>
                    <FormField name="job" htmlFor="job-input-id" label="Job Title">
                        <TextInput id="job-input-id" name="job" />
                    </FormField>
                    <FormField name="email" htmlFor="email-input-id" label="Email">
                        <TextInput id="email-input-id" name="email" />
                    </FormField>
                    <FormField name="phone" htmlFor="phone-input-id" label="Phone">
                        <TextInput id="phone-input-id" name="phone" />
                    </FormField>
                    <FormField name="company" htmlFor="company-input-id" label="Company">
                        <TextInput id="company-input-id" name="company" />
                    </FormField>
                    <FormField name="message" htmlFor="message-id" label="Message">
                        <TextArea id="message-id" name="message" />
                    </FormField>
                    <Box direction="row" gap="medium">
                        <Button
                            type="submit"
                            primary label="Submit"
                            onClick={() => {
                                setSubmitting(true);
                                setTimeout(() => setSubmitting(false), 1000)
                            }}
                            />
                        <Button type="reset" label="Reset" />
                    </Box>
                    { submitting && (
                        <Box gap="medium" pad={{top: 'small'}}>
                            <Spinner alignSelf='center' size="medium"/>
                        </Box>
                    )}
                </Form>
            </Box>
        </Box>
    );
}

export default Contact;